import { useAppDispatch, useAppSelector } from "stores";

import { globalStateSlice } from "./reducers";

// Register state name
export type GlobalStateFieldName =
  | "employeeInfo"
  | "example"
  | "payrollTemplateFields"
  | "orgChart"
  | "employeeListValidate"
  | "periodTimeAttendanceImport"
  | "selectedEmployeeAdjustment"
  | "refetchPayroll"
  | "refetchGroupEmployee"
  | "refetchRole"
  | "salaryAdvanceAdd"
  | "salaryPaymentAdd"
  | "refetchSalary"
  | "salaryAdvanceType"
  | "salaryAdvanceTypeOptions";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useGlobalStateStore = <T = any>({
  name,
  defaultValue = {},
}: {
  name: GlobalStateFieldName;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  defaultValue?: any;
}) => {
  const dispatch = useAppDispatch();
  const data =
    useAppSelector((state) => state?.globalState?.[name]) || defaultValue;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const set = (newParams: any) => {
    dispatch(globalStateSlice.actions.set({ name, param: newParams }));
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const setField = (field: string, value: any) => {
    dispatch(globalStateSlice.actions.setField({ field, value, name }));
  };

  const reset = () => {
    dispatch(globalStateSlice.actions.reset(name));
  };

  return {
    data: data as T,
    set,
    setField,
    reset,
  };
};
